import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { formatDate } from "common/utils/date"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { newDocumentoSelectorDoc } from "features/Crear/redux/slices/newDocumentoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import {
  setShowFechaEmisionModal,
  setShowFechaOperacionModal,
  setShowFechaVencimientoModal,
  setShowTituloModal,
} from "../../redux/slices/newDocumentoSettingsSlice"
import { ButtonAction } from "../ConceptosTable"

const DocumentoFormHeader = ({
  titleDocumento,
  logo,
  serie,
  numero,
  fechaEmision,
  fechaOperacion,
  fechaVencimiento,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { showFechaOperacion, showLogo } = useSelector(
    newDocumentoSettingsSelector
  )
  const { librador } = useSelector(newDocumentoSelectorDoc)

  const {
    activeCompany: { nif },
  } = useUsuarioEmpresaActiva()

  const dispatch = useDispatch()

  return (
    <div className='d-flex justify-content-between'>
      <div className='col-5'>
        <div className='d-flex align-items-center justify-content-start'>
          {showLogo && logo && (
            <img
              style={{
                width: "200px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
              src={logo}
              // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
              alt={t("crear.facturaRec.logoFacLabel")}
              className='mr-3'
            />
          )}

          <h5>{titleDocumento?.toUpperCase()}</h5>
        </div>
      </div>

      <div>
        <div
          className='mb-2 d-flex justify-content-end align-items-center'
          style={{ fontSize: "24px" }}
        >
          <ButtonAction
            // @ts-expect-error TS(2345): Argument of type...
            onClick={() => dispatch(setShowTituloModal(true))}
            iconName='pen'
            classNameIcon='btn-concept__icon'
          />

          <span>
            {serie}-{String(numero).padStart(4, "0")}
          </span>
        </div>

        <div className='tw-flex tw-justify-end tw-items-center'>
          <ButtonAction
            // @ts-expect-error TS(2345): Argument of type...
            onClick={() => dispatch(setShowFechaEmisionModal(true))}
            iconName='pen'
            classNameIcon='tw-w-4 tw-h-4 tw-text-text'
          />

          <p className='m-0'>
            {t("crear.facturaRec.emisionDateLabel")}
            <span className='tw-font-bold'>{formatDate(fechaEmision)}</span>
          </p>
        </div>

        {(librador?.nif === nif || librador?.cif === nif) && (
          <div className='tw-flex tw-justify-end tw-items-center'>
            <ButtonAction
              // @ts-expect-error TS(2345): Argument of type...
              onClick={() => dispatch(setShowFechaVencimientoModal(true))}
              iconName='pen'
              classNameIcon='tw-w-4 tw-h-4 tw-text-text'
            />

            <p className='tw-m-0'>
              {t("crear.facturaRec.vencimientoDateLabel")}
              <span className='tw-font-bold'>
                {formatDate(fechaVencimiento)}
              </span>
            </p>
          </div>
        )}

        {showFechaOperacion && (
          <div className='d-flex align-items-center justify-content-end'>
            <ButtonAction
              // @ts-expect-error TS(2345): Argument of type...
              onClick={() => dispatch(setShowFechaOperacionModal(true))}
              iconName='pen'
              classNameIcon='btn-concept__icon btn-concept__icon'
            />{" "}
            <p className='m-0'>
              {t("crear.facturaRec.opertationDateLabel")}{" "}
              <span className='font-weight-bold'>
                {formatDate(fechaOperacion)}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default DocumentoFormHeader
